const state = {
  isPending: false
};

const getters = {
  isPendingOdooRequest: (state) => state.isPending
};

const mutations = {
  updPendingStatus(state, newStatus) {
    state.isPending = newStatus;
  }
};

const actions = {
  setNewOdooPendingStatus({ commit }, statusPayload) {
    commit('updPendingStatus', statusPayload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
